import type { DeepSearchParams } from "ls/api/cloud/search";
import { queryOptions } from "@tanstack/vue-query";
import { getUserSearchData } from "ls/api/cloud/fs";
import { deepSearch, deepSearchEnabled } from "ls/api/cloud/search";
import { STALE } from "ls/queries/staleTime";

const normalize = (q: string) => q.trim();

export const queries = {
  searchKey: () => ["search"],
  deepSearchKey: (query: string, limit?: number) => [...queries.searchKey(), "deepSearch", query, limit],

  userSearchData: () =>
    queryOptions({
      queryKey: [...queries.searchKey(), "userSearchData"] as const,
      queryFn: ({ signal }) => getUserSearchData({ signal }),
    }),

  deepSearch: (params: DeepSearchParams, enabled: boolean) => {
    const searchQuery = normalize(params.searchQuery);
    return queryOptions({
      queryKey: [...queries.deepSearchKey(searchQuery, params.limit)] as const,
      queryFn: ({ signal }) => deepSearch({ searchQuery, limit: params.limit }, { signal }),
      enabled: Boolean(searchQuery && enabled),
    });
  },

  enabledForUser: () =>
    queryOptions({
      queryKey: [...queries.searchKey(), "enabled"] as const,
      queryFn: ({ signal }) => deepSearchEnabled({ signal }),
      staleTime: STALE.INFINITY,
    }),
};
